import { AxiosInstance } from "axios";
import type {
  TodoistLabel,
  TodoistProject,
  TodoistSection,
} from "./TodoistSourceSettings.types";

export class TodoistSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getProjects(boardId: string, connectionId: string): Promise<TodoistProject[]> {
    const response = await this.client.get<TodoistProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/todoist/projects`,
    );
    return response.data;
  }

  async getSections(
    boardId: string,
    connectionId: string,
    projectId: string,
  ): Promise<TodoistSection[]> {
    const response = await this.client.get<TodoistSection[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/todoist/projects/${encodeURIComponent(projectId)}/sections`,
    );
    return response.data;
  }

  async getLabels(boardId: string, connectionId: string): Promise<TodoistLabel[]> {
    const response = await this.client.get<TodoistLabel[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/todoist/labels`,
    );
    return response.data;
  }
}
